export default "__VITE_ASSET__0bPgJpnt__"